




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks
} from "body-scroll-lock";

@Component({})
export default class ModalEdit extends Vue {
    @Prop()
    public titleModalEdit;
    @Prop()
    public editDialog;
    @Prop()
    public working;

    public handleModalClose() {
        enableBodyScroll(this.$refs.myModalContet);
        this.$emit("modal-close");
    }

    @Watch("editDialog")
    public onShowDialogChange(val) {
        if (val === true) {
            disableBodyScroll(this.$refs.myModalContet);
        } else {
            enableBodyScroll(this.$refs.myModalContet);
        }
    }

    public beforeDestroy() {
        clearAllBodyScrollLocks();
    }
}
